<div *ngIf="alertInfoResponse.length > 0 && showAlerts">
    <div class="alertsection">
        <span id="alertlabel">{{ 'Home.alerts' | translate}}</span>
        <div id="marquee" class="ng-marquee-wrapper">
            <div id="override_marquee_alert" [ngStyle]="{'animation': timeInterval}">
                <span class="zsd_cust_alerts mark"
                    *ngFor="let alert of alertInfoResponse" (click)='alertDiscription(alert)'
                    title=" {{ alert.description.length < 200 ? (alert.description) : (alert.description.slice(0,200) + '...') }} "
                    data-toggle="modal" data-target="#zsd_modal_alert_detail">
                    <em *ngIf="alert.alertType == information" class="fas fa-info-circle"></em>
                    <em *ngIf="alert.alertType == warning" class="fas fa-exclamation-triangle"></em>
                    <em *ngIf="alert.alertType == urgent" class="fas fa-lightbulb"></em>
                    &nbsp;
                    {{alert.title}}
                </span>
            </div>
        </div>
        <span class="zsd-close-alert"><em class="fas fa-times" (click)='hideAlerts()'></em></span> 
    </div>
</div>
<div id="searchandquicklink" [ngStyle]="{'margin-top':topMargin, 'background-image':imagePath}">
    <div class="row override_home_row">
        <div class="col-2"></div>
        <div class="col-8">
            <div class="d-none d-xl-flex d-lg-flex flex-row" id="zsd_home_search">
                 <div class="dropdown">
                    <button type="button" data-toggle="dropdown" class="zsd_search_dropdown_button dropdown-toggle"
                       data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" 
                       id="zsd_home_search_dropDown_button">
                        {{ 'Home.search' | translate}} {{searchPageName | translate}}
                    </button>
                    <div class="dropdown-menu" role="menu">
                        <span *ngIf="showStoreMenu" class="dropdown-item" tabindex="-1" (keyup.enter)="chooseSearchPage('store'); hideDropDown();"
                            (click)="chooseSearchPage('store')">{{ 'Home.store' | translate}} </span>
                        <span *ngIf="showRequestMenu" class="dropdown-item" tabindex="-1" (keyup.enter)="chooseSearchPage('requests'); hideDropDown();"
                            (click)="chooseSearchPage('requests')">{{'Home.request' | translate}}</span>
                        <span *ngIf="showServiceMenu" class="dropdown-item" tabindex="-1" (keyup.enter)="chooseSearchPage('services'); hideDropDown();"
                            (click)="chooseSearchPage('services')">{{'Home.service' | translate}}</span>
                        <span class="dropdown-item" tabindex="-1" (keyup.enter)="chooseSearchPage('selfhelp'); hideDropDown();"
                            (click)="chooseSearchPage('selfhelp')">{{'Home.selfHelp' | translate}}</span>
                        <span *ngIf="showItemMenu" class="dropdown-item" tabindex="-1" (keyup.enter)="chooseSearchPage('items'); hideDropDown();"
                            (click)="chooseSearchPage('items')">{{'Home.item' | translate}}</span>
                        <span *ngIf="showOutageMenu" class="dropdown-item" tabindex="-1" (keyup.enter)="chooseSearchPage('currentoutages'); hideDropDown();"
                            (click)="chooseSearchPage('currentoutages')">{{'Home.outages' | translate}}</span>
                        <span *ngIf="canCusotmerViewPlannedOutages" class="dropdown-item" tabindex="-1" (keyup.enter)="chooseSearchPage('plannedoutages'); hideDropDown();"
                            (click)="chooseSearchPage('plannedoutages')">{{'Home.plannedOutages' | translate}}</span>
                    </div>
                </div>
                <div class="arrow"></div>
                <input id="zsd_home_search_input_box" type="text" title="{{ 'Banner.searchPlaceholder' | translate}}"
                    name="searchTerm" (keyup.enter)="clickSearch()" [(ngModel)]="searchTerm">
                <input id="zsd_home_search_image" type="image" src="img/global_search.png"
                    onmouseover="this.src='img/global_search_onhover.png';"
                    onmouseout="this.src='img/global_search.png';" alt="Submit" width="36" height="36"
                    (click)="clickSearch()">
            </div>
        </div>
        <div class="col-2"></div>
    </div>
    <div class="row override_home_row">
        <div class="col-2">
        </div>
        <div class="col-8">
            <div class="d-none d-xl-flex d-lg-flex flex-row" id="zsd_home_top_cards">
                <div class="card home_card d-none d-xl-inline-block d-lg-inline-block" *ngIf="showStoreMenu"
                    (click)="loadPageOnCardClick('store')" id="storecard">
                    <div class="card-body">
                        <h5 class="card-title">
                            <img src="img/store.png" class="widget-icon" />
                            {{ 'Home.store' | translate }}
                        </h5>
                        <p *ngIf="storeLegend.length <= 85; else elseBlock" class="card-text request-detail"
                            [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(storeLegend)">
                        </p>
                        <ng-template #elseBlock>
                            <p data-toggle="tooltip" data-placement="left"
                                [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(storeLegend.slice(0,85)+'...')"
                                title="{{storeLegend}}"> </p>
                        </ng-template>
                    </div>
                </div>
                <div class="card home_card d-none  d-xl-inline-block d-lg-inline-block" *ngIf="showCreateNewRequest"
                    (click)="loadPageOnCardClick('newrequest')" id="newrequestcard">
                    <div class="card-body">
                        <h5 class="card-title">
                            <img src="img/newrequest.png" class="widget-icon" />
                            {{ 'Home.newrequestwidget' | translate }}
                        </h5>
                        <p *ngIf="createRequestLegend.length <= 85; else elseBlock" class="card-text request-detail"
                            [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(createRequestLegend)">
                        </p>
                        <ng-template #elseBlock>
                            <p data-toggle="tooltip" data-placement="left"
                                [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(createRequestLegend.slice(0,85)+'...')"
                                title="{{createRequestLegend}}"> </p>
                        </ng-template>
                    </div>
                </div>

                <div class="card home_card d-none d-xl-inline-block d-lg-inline-block" id="selfhelpcard"
                    (click)="loadPageOnCardClick('selfhelp')">
                    <div class="card-body">
                        <h5 class="card-title">
                            <img src="img/selfhelp.png" class="widget-icon" />
                            {{ 'Home.selfHelp' | translate }}
                        </h5>
                        <p *ngIf="selfHelpLegend.length <= 85; else elseBlock" class="card-text request-detail"
                            [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(selfHelpLegend)">
                        </p>
                        <ng-template #elseBlock>
                            <p data-toggle="tooltip" data-placement="left"
                                [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(selfHelpLegend.slice(0,85)+'...')"
                                title="{{selfHelpLegend}}"> </p>
                        </ng-template>
                    </div>
                </div>


                <div class="card home_card d-none d-xl-inline-block d-lg-inline-block"
                    (click)="loadPageOnCardClick('outages')" id="outagescard"
                    *ngIf="showOutageMenu || canCusotmerViewPlannedOutages">
                    <div class="card-body">
                        <h5 class="card-title">
                            <img src="img/outages.png" class="widget-icon" />
                            {{ 'Home.outages' | translate }}
                        </h5>
                        <p *ngIf="outagesLegend.length <= 85; else elseBlock" class="card-text request-detail"
                            [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(outagesLegend)">
                        </p>
                        <ng-template #elseBlock>
                            <p data-toggle="tooltip" data-placement="left"
                                [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(outagesLegend.slice(0,85)+'...')"
                                title="{{outagesLegend}}"> </p>
                        </ng-template>
                    </div>
                </div>

            </div>
        </div>

        <div class="col-2">
        </div>
    </div>
    <div class="row d-lg-none d-xl-none col-12" id="zsd_home_top_cards_mobile">
        <div class="col-3">

        </div>
        <div class="col-6">
            <div class="row">
                <div class="col-3 p-2" *ngIf="showStoreMenu" (click)="loadPageOnCardClick('store')">
                    <div class="d-lg-none d-xl-none pt-2 pb-2" id="storecard">
                        <img src="img/store.png" class="mx-auto d-block" />
                    </div>
                </div>
                <div class="col-3 p-2" *ngIf="showCreateNewRequest" (click)="loadPageOnCardClick('newrequest')">
                    <div class="d-lg-none d-xl-none pt-2 pb-2" id="newrequestcard">
                        <img src="img/newrequest.png" class="mx-auto d-block" />
                    </div>
                </div>
                <div class="col-3 p-2" (click)="loadPageOnCardClick('selfhelp')">
                    <div class="d-lg-none d-xl-none pt-2 pb-2" id="selfhelpcard">
                        <img src="img/selfhelp.png" class="mx-auto d-block" />
                    </div>
                </div>
                <div class="col-3 p-2" *ngIf="showOutageMenu || canCusotmerViewPlannedOutages"
                    (click)="loadPageOnCardClick('outages')">
                    <div class="d-lg-none d-xl-none pt-2 pb-2" id="outagescard">
                        <img src="img/outages.png" class="mx-auto d-block" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-3">
        </div>
    </div>
</div>


<!-- Flag valueFromBackend we have to use for Toaster message -->
<div class="row ml-0 mr-0 d-none d-lg-block d-xl-block">
<div class="col-12 customizewidgets pl-4">
    <em class="fa fa-lg fa-redo ml-3" data-toggle="tooltip" title="{{'Home.resetdashlettodefault' | translate}}" (click)="resetToDefaultOrder()"></em>
    <!-- <em class="fa fa-lg fa-info ml-3" data-toggle="tooltip" title="Drag Dashlets to Customize"></em> -->
    <em class="fa fa-lg fa-save ml-3" id="savedashlets" data-toggle="tooltip" title="{{'Home.save' | translate}}" (click)="updateUserDashlets()"></em>
</div>
</div>
<div class="row override_home_row rearrangeclass" id="sortable">
    <!-- Card for Request List -->
    <div id="request" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3" 
    *ngIf="showRequestMenu" [style.order]=indexofrequest>
        <div class="card override_card">
            <div class="card-header home-header">
                <div class="zsd-home-card-header">{{ 'Home.requestheader' | translate}}</div>
                <div class="zsd-home-card-subheader">{{'Home.requestsubheader' | translate}} ({{maxNoOfRequests}})</div>
            </div>

            <div class="card-body override_card_body">
                <table role="presentation" class="table custom-td-width" id="requestTable">
                    <tbody *ngFor="let list of requestListBasicInfoResponse">
                        <tr class="table-body">
                            <td class="request_id_sub striped-td">
                                <span [ngClass]="{'priorityUrgent': list.priorityKey === 'Urgent',
                                    'priorityHigh': list.priorityKey === 'High', 'priorityMedium': list.priorityKey === 'Medium',
                                    'priorityLow': list.priorityKey === 'Low' }">
                                    {{ list.requestNumber }}
                                </span>
                                <span *ngIf='list.subject'><a class="clickableLink" [routerLink]='["/requests"]'
                                        [queryParams]="{searchTerm: showIndividualRequestPage(list.requestNumber)}">
                                        {{list.subject}}</a></span>
                            </td>
                            <td class="striped-td"><span class="request-status">{{ list.status }}</span></td>
                        </tr>
                    </tbody>
                    <tbody>
                        <!-- Spinner -->
                        <div *ngIf="isRequestLoading || requestSpinnerStart" id="spinner" role="progressbar">
                            <div class="text-center col-12">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div *ngIf="requestListBasicInfoResponse?.length == 0 && !isRequestLoading " class="text-center">
                    {{ 'CommonStrings.noRecords' | translate  }}
                </div>
            </div>
            <div class="card-footer home-footer">
                <div *ngIf="requestListBasicInfoResponse?.length > 0" class="text-center"><a
                        [routerLink]='["/requests"]'>{{'Home.viewall' | translate}}</a></div>
            </div>
        </div>
    </div>


    <!-- Card for Request - Approval & Need Info -->

    <div id="awaitingrequest" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3 flex-item sort2" 
    *ngIf="showRequestMenu"  [style.order]=indexofawaitingrequest>
        <div class="card override_card">
            <div class="card-header home-header">
                <div class="zsd-home-card-header">{{ 'Home.requestawaitingapprovalheader' | translate}}</div>
                <div class="zsd-home-card-subheader">{{'Home.requestformesubheader' | translate}}
                    ({{maxNoOfAwaitingRequests}}) </div>
            </div>

            <div class="card-body override_card_body">
                <table role="presentation" class="table custom-td-width" id="requestTable">
                    <tbody *ngFor="let awaitinglist of awaitingRequestLisInfoResponse">
                        <tr class="table-body">
                            <td class="request_id_sub striped-td">
                                <span [ngClass]="{'priorityUrgent': awaitinglist.priorityKey === 'Urgent',
                                        'priorityHigh': awaitinglist.priorityKey === 'High', 'priorityMedium': awaitinglist.priorityKey === 'Medium',
                                        'priorityLow': awaitinglist.priorityKey === 'Low' }">
                                    {{ awaitinglist.requestNumber }}
                                </span>
                                <span *ngIf='awaitinglist.isOnNeedinfo' id="home_requestlist_needInfo"
                                    class="fas fa-allergies"></span>
                                <span *ngIf='awaitinglist.isAwaitingMyApproval' id="home_requestlist_approval"><img
                                        src="img/awaitingMyApproval.png" /></span>
                                <span *ngIf='awaitinglist.subject'>
                                    <a class="clickableLink" [routerLink]='["/requests"]'
                                        [queryParams]="{searchTerm: showIndividualRequestPage(awaitinglist.requestNumber)}">
                                        {{ awaitinglist.subject }}
                                    </a>
                                </span>
                            </td>
                            <td class="striped-td"><span class="request-status">{{ awaitinglist.status }}</span></td>
                        </tr>
                    </tbody>
                    <tbody>
                        <!-- Spinner -->
                        <div *ngIf="isRequestApprovalLoading || requestApprovalSpinnerStart" id="spinner"
                            role="progressbar">
                            <div class="text-center col-12">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div *ngIf="awaitingRequestLisInfoResponse?.length == 0 && !isRequestApprovalLoading"
                    class="text-center">
                    {{ 'CommonStrings.noRecords' | translate  }}
                </div>
            </div>
            <div class="card-footer home-footer">
                <div *ngIf="awaitingRequestLisInfoResponse?.length > 0" class="text-center"><a
                        [routerLink]='["/requests"]'
                        [queryParams]="{awaitingMyInputs:'true',awaitingMyApproval:'true'}">{{'Home.viewall' | translate}}</a>
                </div>
            </div>
        </div>
    </div>

    <!-- Card for Quick Call-->
    <div id="quickcall" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3 flex-item sort3" 
    *ngIf="showQuickCall"  [style.order]=indexofquickcall>

        <div class="card override_card">
            <div class="card-header home-header">
                <div class="zsd-home-card-header">{{'Home.quickcallheader' | translate}}</div>
                <div class="zsd-home-card-subheader">{{'Home.quickcallsubheader' | translate}}
                    ({{quickCallBasicInfoResponse.length}})</div>
            </div>
            <div class="card-body override_card_body">
                <table role="presentation" class="table custom-td-width" id="quickCallTable"
                    *ngIf="(quickCallBasicInfoResponse | sortList: 'priorityWeightage' : -1 : true | slice:0:5) as sortedResult">
                    <tbody>
                        <tr class="table-body" *ngFor="let quickCall of sortedResult"
                            (click)=getQuickCallinfo(quickCall) data-toggle="modal"
                            data-target="#zsd_modal_quickcall_detail">
                            <td class="striped-td" id="">{{ quickCall.name }}</td>
                        </tr>
                    </tbody>
                    <tbody>

                        <div *ngIf="isQuickCallLoading || quickCallSpinnerStart" id="spinner" role="progressbar">
                            <div class="text-center col-12">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div *ngIf="quickCallBasicInfoResponse?.length == 0 && !isQuickCallLoading" class="text-center">
                    {{ 'CommonStrings.noRecords' | translate  }}
                </div>
            </div>
            <div class="card-footer home-footer">
                <div *ngIf="quickCallBasicInfoResponse?.length > 0" class="text-center"><a
                        [routerLink]='["/newrequest"]'>{{'Home.viewall' | translate}}</a></div>
            </div>
        </div>
    </div>


    <!-- Card for Knowledge Base-->
    <div id="kba" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3 flex-item sort4"  
    [style.order]=indexofkba>
        <div class="card override_card">
            <div class="card-header home-header">
                <div class="zsd-home-card-header">{{'Home.kbheader' | translate}}</div>
            </div>
            <div class="kba-dropdown" id="kba-dropdownlist">
                <select class="form-control custom-select" id="kba_option_list"
                    (change)="onChangeKbaType($event.target.value)">
                    <option value="all" selected> {{ 'Home.kbsubheader' | translate }} ({{ kbaResultsCount }})
                    </option>
                    <option value="article"> {{ 'KnowledgeBase.article' | translate }} ({{  kbaArticleCount }})
                    </option>
                    <option value="faqs">{{ 'KnowledgeBase.faqs' | translate }} ({{ kbaFaqCount }})</option>
                    <option value="solution">{{ 'KnowledgeBase.solution' | translate }} ({{ kbaSolutionCount }})
                    </option>
                </select>
            </div>
            <div class="card-body override_card_body">
                <table role="presentation" class="table custom-td-width" id="kbaTable">
                    <tbody>
                        <tr *ngFor="let kba of kbaBasicInfoResponse; let i=index;" class="table-body">
                            <td *ngIf="kba.title.length<120; else elseBlock" id="kbaTitle">
                                <a class="clickableLink"
                                    [routerLink]='["/selfhelp/kba/"+ kba.kbaId ]'>{{ kba.title }}</a></td>
                            <ng-template #elseBlock>
                                <td data-toggle="tooltip" data-placement="left" title="{{kba.title}}" id="kbaTitle">
                                    <a class="clickableLink"
                                        [routerLink]='["/selfhelp/kba/"+ kba.kbaId ]'>{{ kba.title.slice(0,119)+'...' }}
                                    </a></td>
                            </ng-template>
                            <td>
                                <div [attr.id]="'rateYo' + i"></div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody>
                        <!-- Spinner -->
                        <div *ngIf="isKbaLoading || kbaSpinnerStart" id="spinner" role="progressbar">
                            <div class="text-center col-12">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div *ngIf="kbaBasicInfoResponse?.length == 0 && !kbaSpinnerStart" class="text-center">
                    {{ 'CommonStrings.noRecords' | translate  }}
                </div>
            </div>
            <div class="card-footer home-footer">
                <div *ngIf="kbaBasicInfoResponse?.length > 0" class="text-center">
                    <span id="home_footer_kba" (click)="loadSelfHelpPage()"> {{'Home.viewall' | translate}} </span>
                </div>
            </div>
        </div>
    </div>



    <!-- Card for Outages -->
    <div id="outage" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3 flex-item sort5" 
    *ngIf="showOutagesCard"  [style.order]=indexofoutage>
        <div class="card override_card">
            <div class="card-header home-header">
                <div class="zsd-home-card-header">{{ 'Home.outageheader' | translate}}</div>
                <div class="zsd-home-card-subheader">{{'Home.outagesubheader' | translate}} ({{maxNoOfPlannedOutages}})
                </div>
            </div>
            <div class="card-body override_card_body">

                <table role="presentation" class="table custom-td-width" id="c_planned_outages_table">
                    <tbody *ngIf="isPlannedOutageslist">
                        <tr class="table-body" id="c_planned_outages_table_body"
                            *ngFor="let outages of plannedOutagesBasicInfoResponse" class="clickable table-body">
                            <td> {{ outages.startDate }}
                            </td>
                            <td id="outagesReason" *ngIf="outages.reason.length <= 120; else elseBlock">
                                <a class="clickableLink"
                                    [routerLink]='["/outages/plannedoutages/" + outages.plannedOutageId ]'>
                                    {{outages.reason}} </a>
                            </td>
                            <ng-template #elseBlock>
                                <td id="outagesReason" data-toggle="tooltip" data-placement="left"
                                    title="{{outages.reason}}">
                                    <a class="clickableLink"
                                        [routerLink]='["/outages/plannedoutages/" + outages.plannedOutageId ]'>
                                        {{outages.reason.slice(0,119)+'...'}} </a>
                                </td>
                            </ng-template>
                        </tr>
                    </tbody>
                    <tbody>
                        <!-- Spinner -->
                        <div *ngIf="isOutagesLoading || outagesSpinnerStart" id="spinner" role="progressbar">
                            <div class="text-center col-12">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div *ngIf="plannedOutagesBasicInfoResponse?.length == 0 && !isOutagesLoading" class="text-center">
                    {{ 'CommonStrings.noRecords' | translate  }}
                </div>
            </div>
            <div class="card-footer home-footer">
                <div *ngIf="plannedOutagesBasicInfoResponse?.length > 0" class="text-center"><a
                        [routerLink]='["/outages/plannedoutages"]'>{{'Home.viewall' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
    <!-- Card for Survey -->
    <div id="survey" class="col-xl-4 col-lg-4 col-md-6 col-sm-12 col-12 p-3 flex-item sort6"  
    [style.order]=indexofsurvey>
        <div class="card override_card">
            <div class="card-header home-header">
                <div class="zsd-home-card-header">{{ 'Home.survey' | translate}}</div>
                <div class="zsd-home-card-subheader">{{'Home.surveytotake' | translate}} ({{surveyResponse.length}})
                </div>
            </div>
            <div class="card-body override_card_body">
                <table role="presentation" class="table custom-td-width" id="surveyTable">
                    <tbody>
                        <tr class="table-body" *ngFor="let survey of surveyResponse | slice:0:5">
                            <td id="surveyTitle">{{ survey.surveyTitle }}</td>
                            <td *ngIf="!survey.requestId"><a [routerLink]="['/survey', survey.surveyId]">Take Survey</a>
                            </td>
                            <td *ngIf="survey.requestId"><a [routerLink]="['/survey', survey.surveyId]"
                                    [queryParams]="{requestId: survey.requestId}">Take Survey</a></td>
                        </tr>
                    </tbody>
                    <tbody>
                        <!-- Spinner -->
                        <div *ngIf="isSurveyLoading || surveySpinnerStart" id="spinner" role="progressbar">
                            <div class="text-center col-12">
                                <zsd-spinner></zsd-spinner>
                            </div>
                        </div>
                    </tbody>
                </table>
                <div *ngIf="surveyResponse?.length == 0 && !surveySpinnerStart" class="text-center">
                    {{ 'CommonStrings.noRecords' | translate  }}
                </div>
            </div>
            <div class="card-footer home-footer">
                <div *ngIf="surveyResponse?.length > 0" class="text-center"><a
                        [routerLink]='["/survey"]'>{{'Home.viewall' | translate}}</a>
                </div>
            </div>
        </div>
    </div>
</div>
<div *ngIf='quickCallId' class="modal" id="zsd_modal_quickcall_detail" data-backdrop="static" data-keyboard="false">
    <div class="modal-content">
        <div class="modal-header">
            <div id="popupDefaultFont">
                <span *ngIf="quickCallTypeKey==='quickCall'" class="quickCallPopupHeader">
                    <img src="img/quickcallheader.svg"/>  {{'QuickCallList.quickcall' | translate}} </span>
                <span *ngIf="quickCallTypeKey==='groupQuickCall'" class="quickCallPopupHeader">
                    <img src="img/groupquickcallheader.svg"/>  {{'QuickCallList.groupquickcall' | translate}} </span>
                {{quickCallName}}</div>
            <button (click)="resetQuickCall()" type="button" class="close" data-dismiss="modal"><em
                    class="fas fa-times"></em></button>
        </div>
        <div class="modal-body" id="override_modal_body">
            <zsd-quickcalldetail [quickCallId]="quickCallId" [quickCallType]="quickCallTypeKey"
                (clearForm)="resetQuickCall()"></zsd-quickcalldetail>
        </div>
    </div>
</div>

<div *ngIf='isAlertDetailVisible' class="modal" id="zsd_modal_alert_detail" data-backdrop="static"
    data-keyboard="false">
    <div class="alert-modal-content">
        <div *ngIf="alertDetails !== null" id="alertPopupDefaultFont" class="modal-header">
            <em *ngIf="alertDetails?.alertType == information" class="fas fa-info-circle" id="alert-type-icon"></em>
            <em *ngIf="alertDetails?.alertType == warning" class="fas fa-exclamation-triangle" id="alert-type-icon"></em>
            <em *ngIf="alertDetails?.alertType == urgent" class="fas fa-lightbulb" id="alert-type-icon"></em>
            <div>
                <span class="alert-pageheading-font active">{{'Alert.alertDetailHeader' | translate}}</span>
            </div>
            <button (click)="resetAlert()" type="button" class="close" data-dismiss="modal">
                <em class="fas fa-times"></em>
            </button>
        </div>
        <div class="modal-body" id="alert_modal_body">
            <table role="presentation" class="table alert-table">
                <div *ngIf="isLoading || requestSpinnerStart" id="spinner" role="progressbar">
                    <div class="text-center col-12">
                        <zsd-spinner></zsd-spinner>
                    </div>
                </div>
                <tbody *ngIf="alertDetails !== null">
                    <tr id="alertDateTitle">
                        <td style="width:80%;"><span class="alert-title">{{ alertDetails?.title }}</span></td>
                        <td style="width:20%;"><span class="alert-date">({{ alertDetails?.publishDate }})</span> </td>
                    </tr>
                    <tr>
                        <td colspan="2" [innerHTML]="alertDetails?.description"></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>